/**
 * @license
 * Copyright (c) 2018 Crius Authors. All rights reserved.
 */

import '@polymer/polymer/polymer-element.js';

const $_documentContainer = document.createElement('template');
$_documentContainer.innerHTML = `
<dom-module id="cs-shared-styles-form-select">
	<template>
		<custom-style>
			<style>
    :host {
        display: inline-block;
        max-width: 100%;
        position: relative;
        -webkit-tap-highlight-color: transparent
    }

    :host(:hover) {
        cursor: pointer
    }

    :host([disabled]) {
        pointer-events: none
    }

    .cspl-dropdown__selected {
        align-items: center;
        background-color: #fff;
        color: var(--cs-dark-color);
        cursor: pointer;
        display: flex;
        flex-wrap: wrap;
        height: 48px;
        justify-content: space-between;
        outline: 0;
        padding: 8px 24px 8px 24px;
        position: relative;
        text-transform: capitalize;
        width: 100%
    }

    @media only screen and (min-width:1024px) {
        .cspl-dropdown__selected {
            height: 60px;
            padding-left: 32px;
            padding-right: 32px
        }
    }

    .cspl-dropdown__selected-container {
        align-items: center;
        display: flex;
        justify-content: space-between;
        width: 100%
    }

    :host([theme=light]) .cspl-dropdown__selected {
        background-color: var(--cs-dark-color);
        color: var(--cs-light-color)
    }

    :host([disabled]) .cspl-dropdown__selected {
        background-color: var(--cs-light-color);
        color: #c2c2c2;
        text-transform: capitalize
    }

    :host([theme=light][disabled]) .cspl-dropdown__selected {
        background-color: var(--cs-dark-color);
        color: #585858
    }

    :host([background-color=none]) .cspl-dropdown__selected,
    :host([theme=light][disabled][background-color=none]) .cspl-dropdown__selected {
        background-color: transparent
    }

    :host([background-color=dark]) .cspl-dropdown__selected,
    :host([theme=light][disabled][background-color=dark]) .cspl-dropdown__selected {
        background-color: var(--cs-dark-color)
    }

    :host([background-color=light]) .cspl-dropdown__selected,
    :host([theme=light][disabled][background-color=light]) .cspl-dropdown__selected {
        background-color: #fff
    }

    .cspl-dropdown__selected-label {
        color: #585858;
        font-size: 13px;
        line-height: 14px;
        transition: var(--cs-interface-expansion);
        width: 100%
    }

    :host([wf-loading]) .cspl-dropdown__selected-label {
        opacity: 0
    }

    :host([theme=light]) .cspl-dropdown__selected-label {
        color: #a3a3a3
    }

    .cspl-dropdown__items-container::before,
    .cspl-dropdown__selected::before {
        border: solid 2px var(--cs-dark-color);
        border-radius: 3px;
        bottom: 0;
        content: "";
        left: 0;
        position: absolute;
        right: 0;
        top: 0;
        transition: border-width .1s, bottom .1s, left .1s, right .1s, top .1s
    }

    :host([theme=light]) .cspl-dropdown__items-container::before,
    :host([theme=light]) .cspl-dropdown__selected::before {
        border-color: var(--cs-light-color)
    }

    :host([error]) .cspl-dropdown__items-container::before,
    :host([error]) .cspl-dropdown__selected::before {
        border-color: var(--cs-error-color)
    }

    :host(:hover) .cspl-dropdown__items-container::before,
    :host(:hover) .cspl-dropdown__selected::before {
        border-width: 2px;
        bottom: -3px;
        left: -3px;
        right: -3px;
        top: -3px
    }

    :host([open]) .cspl-dropdown__items-container::before,
    :host([open]) .cspl-dropdown__selected::before {
        border-width: 3px;
        bottom: -4px;
        left: -4px;
        right: -4px;
        top: -4px
    }

    .cspl-dropdown__selected-text {
        overflow: hidden;
        text-overflow: ellipsis;
        transition: var(--cs-interface-expansion);
        white-space: nowrap;
        width: 100%
    }

    :host([wf-loading]) .cspl-dropdown__selected-text {
        opacity: 0
    }

    .cspl-dropdown__chevron {
        color: var(--cs-dark-color);
        height: 8px;
        margin-left: 5px;
        position: relative;
        width: 16px
    }

    .cspl-dropdown__chevron--no-margin {
        margin-left: 0
    }

    :host([text-color=light]) .cspl-dropdown__chevron,
    :host([theme=light]) .cspl-dropdown__chevron {
        color: var(--cs-light-color)
    }

    :host([text-color=dark]) .cspl-dropdown__chevron {
        color: var(--cs-dark-color)
    }

    :host([text-color=brand]) .cspl-dropdown__chevron {
        color: var(--cs-theme-color)
    }

    :host([disabled]) .cspl-dropdown__chevron {
        color: #c2c2c2
    }

    :host([disabled][theme=light]) .cspl-dropdown__chevron {
        color: #585858
    }

    .cspl-dropdown__chevron::after,
    .cspl-dropdown__chevron::before {
        border-radius: 10px;
        border-top: 2px solid currentColor;
        content: "";
        height: 2px;
        position: absolute;
        top: 50%;
        transition: transform var(--cs-transition-duration) var(--cs-transition-easing);
        width: 10px
    }

    .cspl-dropdown__chevron::before {
        left: 0
    }

    .cspl-dropdown__chevron::after {
        right: 0
    }

    .cspl-dropdown__chevron::before,
    :host([open]) .cspl-dropdown__chevron::after {
        transform: rotate(45deg)
    }

    .cspl-dropdown__chevron::after,
    :host([open]) .cspl-dropdown__chevron::before {
        transform: rotate(-45deg)
    }

    .cspl-dropdown__items-container {
        background-color: #fff;
        left: 0;
        min-width: 100%;
        opacity: 0;
        outline: 0;
        position: absolute;
        top: 0;
        width: 100%;
        z-index: -1
    }

    :host([open]) .cspl-dropdown__items-container {
        opacity: 1;
        width: auto;
        z-index: 2
    }

    :host([open]) .cspl-dropdown__items-container::before {
        background-color: #fff;
        box-shadow: 0 14px 20px 0 rgba(0, 0, 0, .16)
    }

    :host([theme=light]) .cspl-dropdown__items-container::before {
        background-color: var(--cs-dark-color)
    }

    .cspl-dropdown__items {
        list-style-type: none;
        margin: 0;
        max-height: 48px;
        overflow-y: auto;
        padding-left: 0;
        position: relative;
        transition: max-height .1s ease-in-out
    }

    :host([open]) .cspl-dropdown__items {
        max-height: 215px
    }

    @media only screen and (min-width:1024px) {
        .cspl-dropdown__items {
            max-height: 40px
        }

        :host(:hover) .cspl-dropdown__items {
            max-height: 48px
        }

        :host([open]) .cspl-dropdown__items {
            max-height: 270px
        }
    }

    @media only screen and (min-width:1456px) {
        .cspl-dropdown__items {
            max-height: 60px
        }
    }

    .cspl-dropdown__item {
        display: none;
        margin-bottom: 0;
        margin-top: 0;
        position: relative
    }

    .cspl-dropdown__item-current,
    :host([open]) .cspl-dropdown__item {
        display: block
    }

    .cspl-dropdown__item::before {
        display: none
    }

    .cspl-dropdown__item-icon {
        margin-right: 10px
    }

    .cspl-dropdown__link {
        align-items: center;
        color: var(--cs-dark-color);
        display: flex;
        height: 48px;
        justify-content: space-between;
        padding-left: 24px;
        padding-right: 24px;
        text-decoration: none;
        white-space: nowrap
    }

    :host([theme=light]) .cspl-dropdown__link {
        color: var(--cs-light-color)
    }

    .cspl-dropdown__link::after {
        border-top: solid 2px #eaeaea;
        content: "";
        left: 24px;
        position: absolute;
        top: 0;
        width: calc(100% - 48px)
    }

    .cspl-dropdown__link-text {
        padding-right: 16px;
        transition: transform var(--cs-interface-expansion) ease-in-out
    }

    .cspl-dropdown__item--highlight .cspl-dropdown__link-text,
    .cspl-dropdown__link:hover .cspl-dropdown__link-text {
        transform: translateX(8px)
    }

    :host([theme=light]) .cspl-dropdown__link::after {
        border-color: #585858
    }

    .cspl-dropdown__item:first-child .cspl-dropdown__link::after {
        display: none
    }

    @media only screen and (min-width:1024px) {
        .cspl-dropdown__link {
            height: 60px;
            padding-left: 32px;
            padding-right: 32px
        }

        .cspl-dropdown__link::after {
            left: 32px;
            width: calc(100% - 64px)
        }
    }

    .cspl-dropdown__checkmark {
        fill: var(--cs-dark-color);
        height: 16px;
        max-width: 16px;
        min-width: 16px;
        visibility: hidden;
        width: 16px
    }

    :host([theme=light]) .cspl-dropdown__checkmark {
        fill: var(--cs-light-color)
    }

    .cspl-dropdown__item-current .cspl-dropdown__checkmark {
        visibility: visible
    }

    :host([theme=light]) .cspl-dropdown__items-container::before {
        background-color: var(--cs-dark-color)
    }
</style>
		</custom-style>
	</template>
</dom-module>`;

document.head.appendChild($_documentContainer.content);